import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import AjouterProjet from './Ajouter/AjouterProjet';
import ProfilProjet from './ProfilProjet/ProfilProjet';
import ConteneurInformation from '../ConteneurInformation/ConteneurInformation';
import TableauProjet from './TableauProjet/TableauProjet';
import Bouton from '../UI/Bouton/Bouton';

import * as indexConteneurInfo from '../../ressources/glossaires/glossaire_conteneur_info';
import * as type_btn from '../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../services/actions';
import { checkMot } from '../../ressources/functionJS/checkMot';
import S from './Projet.module.scss';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';

const Projet = () => {
  const dispatch = useDispatch();

  // State hooks
  const [parametresSelectione, setParametresSelectione] = useState({});
  const [montrerInfo, setMontrerInfo] = useState(false);
  const [montrerInfoFull, setMontrerInfoFull] = useState(false);
  const [indexConteneurInfoState, setIndexConteneurInfoState] = useState(null);

  // Event handlers
  const ligneSelectione = (info) => {
    setParametresSelectione(info);
    setIndexConteneurInfoState(indexConteneurInfo.profil);
    setMontrerInfo(true);
  };

  const commutateurInfoCreer = () => {
    if (montrerInfo) {
      setMontrerInfo(false);
      setMontrerInfoFull(false);
    } else {
      setMontrerInfo(true);
    }
  };

  const commutateurInfoFull = () => {
    setMontrerInfoFull((prev) => !prev);
  };

  const commutateurAnnuler = () => {
    dispatch(actions.ajouterAlerte('warning', 'Annuler', 'Projet non créé'));
    setMontrerInfo(false);
    setIndexConteneurInfoState(null);
  };

  const creerProjet = () => {
    setMontrerInfo(true);
    setIndexConteneurInfoState(indexConteneurInfo.ajouterForm);
  };

  // Style calculations
  const styleConteneurCentralGauche = [S.ConteneurCentralGauche];
  const styleConteneurCentralDroite = [S.ConteneurCentralDroite];
  const commutateurClasses = [S.CommutateurInfo];

  if (montrerInfo && montrerInfoFull) {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFull);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheVoid);
  } else if (montrerInfo && !montrerInfoFull) {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteOuvert);
  } else {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFermer);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheFermer);
  }

  return (
    <>
      <div className={[S.ConteneurProjet].join(' ')}>
        <div className={styleConteneurCentralGauche.join(' ')}>
          <TableauProjet
            projetSelectione={ligneSelectione}
            creer={creerProjet}
          />
          <div className={S.titleModule}> {checkMot('projets')} </div>
        </div>
        <div className={styleConteneurCentralDroite.join(' ')}>
          <Bouton
            ajoutClass={[commutateurClasses, S.expandTO].join(' ')}
            cliquer={commutateurInfoCreer}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromLeft size={15} />
          </Bouton>
          <Bouton
            ajoutClass={S.expand}
            cliquer={commutateurInfoFull}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromRight size={15} />
          </Bouton>
          <ConteneurInformation
            selectionInfo={indexConteneurInfoState}
            ajouterForm={
              <AjouterProjet
                ajouterAlerte={(typeAlerte, titre, corps) =>
                  dispatch(actions.ajouterAlerte(typeAlerte, titre, corps))
                }
                annuler={commutateurAnnuler}
                ajouter={(infoNouveauProjet) =>
                  dispatch(actions.reqAjouterProjet(infoNouveauProjet))
                }
              />
            }
            profil={
              <ProfilProjet
                infoProjet={parametresSelectione}
                reqModifier={(infoModifierProjet) =>
                  dispatch(actions.reqModifierProjet(infoModifierProjet))
                }
                reqSupprimer={(idProjet) =>
                  dispatch(actions.reqSupprimerProjet(idProjet))
                }
              />
            }
          />
        </div>
      </div>
    </>
  );
};

export default Projet;
